module.exports = __webpack_public_path__ + "img/1f344.ea1b8b2.svg";